export default __webpack_public_path__ + "static/SC_Step_3-d663fc80654f70591a2bdceffe43ec06.svg";